import { cloneDeep, last } from 'lodash';
import { convertNumberToLetter, controlConfig_commissionRate } from '_libs/util';

/**
 *
 * @param {*} data
 * @param {*} isApp
 * @param {*} defalutPlanCode - 指定 planCode
 * @returns
 */
export function getPremiumRateList({
  data,
  defalutPlanCode,
  isTXSystem,
  isRepeatPremiumRateWithFactors,
}) {
  if (!data.premiumRateList || !data.premiumRateList.length)
    return {
      planCodeDefault: '1',
      premiumRateList: [],
    };
  const controlConfig = controlConfig_commissionRate[data.productId];

  let premiumRateList = cloneDeep(data.premiumRateList);
  if (data.productId == '345') {
    // 2025-10-29 CMSX-5609 345平安团体无忧保(工标B版) 只保留前两个费率档位，下架第三个档位
    premiumRateList = premiumRateList.filter((item) => item.planCode != '3');
  } else if (data.productId == '205' && data.newBarPremiumRateList) {
    // 205 已经下架，可以不用管
    // 写死产品id 205 费率档位区间取值
    premiumRateList = data.newBarPremiumRateList;
  } else {
    premiumRateList = data.premiumRateList;
  }

  premiumRateList.sort((a, b) => {
    return a.premiumRate - b.premiumRate;
  });

  // 80124佣金率选中区间改造 - 已下架
  let premiumRateList80124 = [];
  if (isRepeatPremiumRateWithFactors) {
    let premiumRateList80124Value = [];
    data.premiumRateList.forEach((item) => {
      if (!premiumRateList80124Value.includes(item.premiumRate)) {
        premiumRateList80124Value.push(item.premiumRate);
      }
    });
    if (premiumRateList80124Value && premiumRateList80124Value.length) {
      premiumRateList80124Value.forEach((item, index) => {
        premiumRateList80124.push({
          planCode: index + 1,
          premiumRate: item,
          name: isTXSystem ? convertNumberToLetter(index) + '档' : `${item}%`
        });
      });
    }
  }

  premiumRateList.forEach((item, index) => {
    let controlName = '';
    if (controlConfig) {
      const { planCodeSetStr } = controlConfig;
      if (planCodeSetStr) {
        const str = planCodeSetStr[item.planCode];
        if (str) {
          controlName = str;
        }
      }
    }
    if (controlName) {
      item.name = controlName;
    } else {
      item.name = `${item.premiumRate}%`;
      if (isTXSystem) {
        item.name = convertNumberToLetter(index) + '档';
      }
    }
  });

  // 默认设置为最大
  let planCodeDefault = isRepeatPremiumRateWithFactors
    ? last(premiumRateList80124).planCode
    : last(premiumRateList).planCode;

  // 写死产品id 2001 计划 1 - 已下架
  if (
    // data.productId == '2001' ||
    data.factorRate &&
    data.factorRate.planCodes &&
    data.factorRate.planCodes.length
  ) {
    planCodeDefault = '1';
  }

  // 写死产品id 205 计划 3
  if (data.productId == '205') {
    planCodeDefault = '3';
  }

  if (data.productId == '331') {
    planCodeDefault = '1';
  }
  if (data.productId == '332') {
    planCodeDefault = '4';
  }

  // 如果有指定佣金率
  if (defalutPlanCode) {
    if (premiumRateList.find((item) => item.planCode == defalutPlanCode)) {
      planCodeDefault = defalutPlanCode;
    }
  }

  console.log('💰 默认佣金档位', planCodeDefault);
  return {
    planCodeDefault,
    premiumRateList: isRepeatPremiumRateWithFactors ? premiumRateList80124 : premiumRateList,
  };
}

/**
 * 设置 planCode，如果当前 planCode 不存在于 premiumRateList 中，则取最大的
 * 没有佣金率列表则默认取 1
 * @param {Array} premiumRateList 佣金率列表
 * @param {string} currentPlanCode 当前 planCode
 * @returns {string} 可用的 planCode
 */
export const getAvailablePlanCode = (premiumRateList, currentPlanCode) => {
  let newPlanCode = currentPlanCode || '1';
  if (!premiumRateList || premiumRateList.length === 0) {
    newPlanCode = '1';
  } else if (!premiumRateList.find((item) => item.planCode == currentPlanCode)) {
    newPlanCode = last(premiumRateList).planCode;
    console.log(`😥 之前的 planCode ${currentPlanCode} 已经不存在，取最大的 planCode ${newPlanCode}`);
  }
  console.log('⭕ getAvailablePlanCode 可用的planCode', newPlanCode);
  return newPlanCode
};



// WEBPACK FOOTER //
// ./src/util/premiumRate.js